export default "__VITE_ASSET__CJ$YnbDg__"